import React from 'react';
// import { Route } from 'react-router-dom';
// import Layout from '../../../Layout/index';
import Layout from '../../../Layout/index';
import PndRouter from './PndRouter';
import ProtectedRoute from './ProtectedRoute';
import ChatNotification from '../../../../shared/components/notification/ChatNotification';

export default () => (
  <div>
   <Layout/>
    <div className="container__wrap">
      <ProtectedRoute path="/web_app" component={PndRouter} />
      <ChatNotification />
    </div>
  </div>
);
